import { PRIVACY_COLLECTION_NOTICE_URL } from 'shared/constants/constants';

export const PlantDesignDeclarationPage = {
  consent: `##### I declare that:

  *   I am authorised to make this application as, or on behalf of the proposed authority holder (registration holder).
  *   The particulars specified in this application and any attachments are to the best of my knowledge, true and correct in every detail.
  *   The registration holder does not hold an equivalent registration for the same design with another state or commonwealth Work Health and Safety Regulator.
  
  ##### I acknowledge that:
  
  *   I understand that the Department of Customer Service may require me, or an authorised person, to provide information relevant to the investigation of this application.
  *   I consent to the Department of Customer Service to make enquiries and exchange information with other NSW government agencies, or other states, territories and/or the Commonwealth, regarding any matter relevant to the assessment of this application or for compliance purposes.
  *   I accept that failure to supply information required on this application may delay the processing of this application.
  *   I have read and understood the [Privacy Collection Notice](${PRIVACY_COLLECTION_NOTICE_URL}) and I consent to the collection, use and disclosure of my personal information in accordance with that Notice.`,
};
